// Generated by tools/proto/generate.cjs. DO NOT EDIT.
import { GeneratedType } from "@cosmjs/proto-signing";
import { AddressActivity } from "./types/structs/structs/address";
import { AddressAssociation } from "./types/structs/structs/address";
import { AddressNonceRecord } from "./types/structs/structs/address";
import { AddressRecord } from "./types/structs/structs/address";
import { Agreement } from "./types/structs/structs/agreement";
import { Allocation } from "./types/structs/structs/allocation";
import { EventAddressActivity } from "./types/structs/structs/events";
import { EventAddressAssociation } from "./types/structs/structs/events";
import { EventAgreement } from "./types/structs/structs/events";
import { EventAllocation } from "./types/structs/structs/events";
import { EventAlphaDefuse } from "./types/structs/structs/events";
import { EventAlphaDefuseDetail } from "./types/structs/structs/events";
import { EventAlphaInfuse } from "./types/structs/structs/events";
import { EventAlphaInfuseDetail } from "./types/structs/structs/events";
import { EventAlphaRefine } from "./types/structs/structs/events";
import { EventAlphaRefineDetail } from "./types/structs/structs/events";
import { EventAttack } from "./types/structs/structs/events";
import { EventAttackDefenderCounterDetail } from "./types/structs/structs/events";
import { EventAttackDetail } from "./types/structs/structs/events";
import { EventAttackShotDetail } from "./types/structs/structs/events";
import { EventDelete } from "./types/structs/structs/events";
import { EventFleet } from "./types/structs/structs/events";
import { EventGrid } from "./types/structs/structs/events";
import { EventGuild } from "./types/structs/structs/events";
import { EventGuildBankAddress } from "./types/structs/structs/events";
import { EventGuildBankAddressDetail } from "./types/structs/structs/events";
import { EventGuildBankConfiscateAndBurn } from "./types/structs/structs/events";
import { EventGuildBankConfiscateAndBurnDetail } from "./types/structs/structs/events";
import { EventGuildBankConvert } from "./types/structs/structs/events";
import { EventGuildBankConvertDetail } from "./types/structs/structs/events";
import { EventGuildBankConvertToken } from "./types/structs/structs/events";
import { EventGuildBankConvertTokenDetail } from "./types/structs/structs/events";
import { EventGuildBankMint } from "./types/structs/structs/events";
import { EventGuildBankMintDetail } from "./types/structs/structs/events";
import { EventGuildBankRedeem } from "./types/structs/structs/events";
import { EventGuildBankRedeemDetail } from "./types/structs/structs/events";
import { EventGuildMembershipApplication } from "./types/structs/structs/events";
import { EventGuildRankPermission } from "./types/structs/structs/events";
import { EventGuildRankPurchase } from "./types/structs/structs/events";
import { EventHashSuccess } from "./types/structs/structs/events";
import { EventHashSuccessDetail } from "./types/structs/structs/events";
import { EventInfusion } from "./types/structs/structs/events";
import { EventOreMigrate } from "./types/structs/structs/events";
import { EventOreMigrateDetail } from "./types/structs/structs/events";
import { EventOreMine } from "./types/structs/structs/events";
import { EventOreMineDetail } from "./types/structs/structs/events";
import { EventOreTheft } from "./types/structs/structs/events";
import { EventOreTheftDetail } from "./types/structs/structs/events";
import { EventOwnerReactorDiversity } from "./types/structs/structs/events";
import { EventOwnerReactorDiversityReset } from "./types/structs/structs/events";
import { EventPermission } from "./types/structs/structs/events";
import { EventPlanet } from "./types/structs/structs/events";
import { EventPlanetAttribute } from "./types/structs/structs/events";
import { EventPlayer } from "./types/structs/structs/events";
import { EventPlayerHalted } from "./types/structs/structs/events";
import { EventPlayerResumed } from "./types/structs/structs/events";
import { EventProvider } from "./types/structs/structs/events";
import { EventProviderAddress } from "./types/structs/structs/events";
import { EventProviderAddressDetail } from "./types/structs/structs/events";
import { EventProviderGrantGuild } from "./types/structs/structs/events";
import { EventProviderGrantGuildDetail } from "./types/structs/structs/events";
import { EventProviderRevenueShortfall } from "./types/structs/structs/events";
import { EventProviderRevenueShortfallDetail } from "./types/structs/structs/events";
import { EventProviderRevokeGuild } from "./types/structs/structs/events";
import { EventProviderRevokeGuildDetail } from "./types/structs/structs/events";
import { EventRaid } from "./types/structs/structs/events";
import { EventRaidDetail } from "./types/structs/structs/events";
import { EventReactor } from "./types/structs/structs/events";
import { EventReactorCommissionRevision } from "./types/structs/structs/events";
import { EventReactorCommissionRevisionReset } from "./types/structs/structs/events";
import { EventReactorStakeCap } from "./types/structs/structs/events";
import { EventStruct } from "./types/structs/structs/events";
import { EventStructAttribute } from "./types/structs/structs/events";
import { EventStructDefender } from "./types/structs/structs/events";
import { EventStructDefenderClear } from "./types/structs/structs/events";
import { EventStructDefenderClearDetail } from "./types/structs/structs/events";
import { EventStructType } from "./types/structs/structs/events";
import { EventSubstation } from "./types/structs/structs/events";
import { EventTime } from "./types/structs/structs/events";
import { EventTimeDetail } from "./types/structs/structs/events";
import { EventVaultAddress } from "./types/structs/structs/events";
import { EventVaultAddressDetail } from "./types/structs/structs/events";
import { EventVaultDelegationMigration } from "./types/structs/structs/events";
import { EventVaultRedelegationMigration } from "./types/structs/structs/events";
import { EventVaultUnbondingMigration } from "./types/structs/structs/events";
import { EventVaultVestingMigration } from "./types/structs/structs/events";
import { Fleet } from "./types/structs/structs/fleet";
import { FleetAttributeRecord } from "./types/structs/structs/fleet";
import { GenesisState } from "./types/structs/structs/genesis";
import { GridAttributes } from "./types/structs/structs/grid";
import { GridRecord } from "./types/structs/structs/grid";
import { Guild } from "./types/structs/structs/guild";
import { GuildMembershipApplication } from "./types/structs/structs/guild";
import { GuildRankPermissionRecord } from "./types/structs/structs/permission";
import { Infusion } from "./types/structs/structs/infusion";
import { InternalAddressAssociation } from "./types/structs/structs/address";
import { Module } from "./types/structs/structs/module/module";
import { MsgAddressRegister } from "./types/structs/structs/tx";
import { MsgAddressRegisterResponse } from "./types/structs/structs/tx";
import { MsgAddressRevoke } from "./types/structs/structs/tx";
import { MsgAddressRevokeResponse } from "./types/structs/structs/tx";
import { MsgAgreementCapacityDecrease } from "./types/structs/structs/tx";
import { MsgAgreementCapacityIncrease } from "./types/structs/structs/tx";
import { MsgAgreementClose } from "./types/structs/structs/tx";
import { MsgAgreementDurationIncrease } from "./types/structs/structs/tx";
import { MsgAgreementOpen } from "./types/structs/structs/tx";
import { MsgAgreementResponse } from "./types/structs/structs/tx";
import { MsgAllocationCreate } from "./types/structs/structs/tx";
import { MsgAllocationCreateResponse } from "./types/structs/structs/tx";
import { MsgAllocationDelete } from "./types/structs/structs/tx";
import { MsgAllocationDeleteResponse } from "./types/structs/structs/tx";
import { MsgAllocationTransfer } from "./types/structs/structs/tx";
import { MsgAllocationTransferResponse } from "./types/structs/structs/tx";
import { MsgAllocationUpdate } from "./types/structs/structs/tx";
import { MsgAllocationUpdateResponse } from "./types/structs/structs/tx";
import { MsgFleetMove } from "./types/structs/structs/tx";
import { MsgFleetMoveResponse } from "./types/structs/structs/tx";
import { MsgGuildBankConfiscateAndBurn } from "./types/structs/structs/tx";
import { MsgGuildBankConfiscateAndBurnResponse } from "./types/structs/structs/tx";
import { MsgGuildBankConvert } from "./types/structs/structs/tx";
import { MsgGuildBankConvertResponse } from "./types/structs/structs/tx";
import { MsgGuildBankConvertToken } from "./types/structs/structs/tx";
import { MsgGuildBankConvertTokenResponse } from "./types/structs/structs/tx";
import { MsgGuildBankMint } from "./types/structs/structs/tx";
import { MsgGuildBankMintResponse } from "./types/structs/structs/tx";
import { MsgGuildBankRedeem } from "./types/structs/structs/tx";
import { MsgGuildBankRedeemResponse } from "./types/structs/structs/tx";
import { MsgGuildCreate } from "./types/structs/structs/tx";
import { MsgGuildCreateResponse } from "./types/structs/structs/tx";
import { MsgGuildMembershipInvite } from "./types/structs/structs/tx";
import { MsgGuildMembershipInviteApprove } from "./types/structs/structs/tx";
import { MsgGuildMembershipInviteDeny } from "./types/structs/structs/tx";
import { MsgGuildMembershipInviteRevoke } from "./types/structs/structs/tx";
import { MsgGuildMembershipJoin } from "./types/structs/structs/tx";
import { MsgGuildMembershipJoinByRankPurchase } from "./types/structs/structs/tx";
import { MsgGuildMembershipJoinProxy } from "./types/structs/structs/tx";
import { MsgGuildMembershipKick } from "./types/structs/structs/tx";
import { MsgGuildMembershipRequest } from "./types/structs/structs/tx";
import { MsgGuildMembershipRequestApprove } from "./types/structs/structs/tx";
import { MsgGuildMembershipRequestDeny } from "./types/structs/structs/tx";
import { MsgGuildMembershipRequestRevoke } from "./types/structs/structs/tx";
import { MsgGuildMembershipResponse } from "./types/structs/structs/tx";
import { MsgGuildRankPurchase } from "./types/structs/structs/tx";
import { MsgGuildRankPurchaseResponse } from "./types/structs/structs/tx";
import { MsgGuildUpdateBankConvertInFee } from "./types/structs/structs/tx";
import { MsgGuildUpdateBankConvertOutFee } from "./types/structs/structs/tx";
import { MsgGuildUpdateEndpoint } from "./types/structs/structs/tx";
import { MsgGuildUpdateEntryRank } from "./types/structs/structs/tx";
import { MsgGuildUpdateEntrySubstationId } from "./types/structs/structs/tx";
import { MsgGuildUpdateJoinInfusionMinimum } from "./types/structs/structs/tx";
import { MsgGuildUpdateJoinInfusionMinimumBypassByInvite } from "./types/structs/structs/tx";
import { MsgGuildUpdateJoinInfusionMinimumBypassByRequest } from "./types/structs/structs/tx";
import { MsgGuildUpdateName } from "./types/structs/structs/tx";
import { MsgGuildUpdateOwnerId } from "./types/structs/structs/tx";
import { MsgGuildUpdatePfp } from "./types/structs/structs/tx";
import { MsgGuildUpdatePrimaryReactor } from "./types/structs/structs/tx";
import { MsgGuildUpdateRankPurchase } from "./types/structs/structs/tx";
import { MsgGuildUpdateResponse } from "./types/structs/structs/tx";
import { MsgPermissionGrantOnAddress } from "./types/structs/structs/tx";
import { MsgPermissionGrantOnObject } from "./types/structs/structs/tx";
import { MsgPermissionGuildRankRevoke } from "./types/structs/structs/tx";
import { MsgPermissionGuildRankSet } from "./types/structs/structs/tx";
import { MsgPermissionResponse } from "./types/structs/structs/tx";
import { MsgPermissionRevokeOnAddress } from "./types/structs/structs/tx";
import { MsgPermissionRevokeOnObject } from "./types/structs/structs/tx";
import { MsgPermissionSetOnAddress } from "./types/structs/structs/tx";
import { MsgPermissionSetOnObject } from "./types/structs/structs/tx";
import { MsgPlanetExplore } from "./types/structs/structs/tx";
import { MsgPlanetExploreResponse } from "./types/structs/structs/tx";
import { MsgPlanetRaidComplete } from "./types/structs/structs/tx";
import { MsgPlanetRaidCompleteResponse } from "./types/structs/structs/tx";
import { MsgPlanetUpdateName } from "./types/structs/structs/tx";
import { MsgPlanetUpdateResponse } from "./types/structs/structs/tx";
import { MsgPlayerResume } from "./types/structs/structs/tx";
import { MsgPlayerResumeResponse } from "./types/structs/structs/tx";
import { MsgPlayerSend } from "./types/structs/structs/tx";
import { MsgPlayerSendResponse } from "./types/structs/structs/tx";
import { MsgPlayerUpdateGuildRank } from "./types/structs/structs/tx";
import { MsgPlayerUpdateGuildRankResponse } from "./types/structs/structs/tx";
import { MsgPlayerUpdateName } from "./types/structs/structs/tx";
import { MsgPlayerUpdatePfp } from "./types/structs/structs/tx";
import { MsgPlayerUpdatePfpClientRenderAttributes } from "./types/structs/structs/tx";
import { MsgPlayerUpdatePrimaryAddress } from "./types/structs/structs/tx";
import { MsgPlayerUpdatePrimaryAddressResponse } from "./types/structs/structs/tx";
import { MsgPlayerUpdateResponse } from "./types/structs/structs/tx";
import { MsgProviderCreate } from "./types/structs/structs/tx";
import { MsgProviderDelete } from "./types/structs/structs/tx";
import { MsgProviderResponse } from "./types/structs/structs/tx";
import { MsgProviderUpdateAccessPolicy } from "./types/structs/structs/tx";
import { MsgProviderUpdateCapacityMaximum } from "./types/structs/structs/tx";
import { MsgProviderUpdateCapacityMinimum } from "./types/structs/structs/tx";
import { MsgProviderUpdateDurationMaximum } from "./types/structs/structs/tx";
import { MsgProviderUpdateDurationMinimum } from "./types/structs/structs/tx";
import { MsgProviderWithdrawBalance } from "./types/structs/structs/tx";
import { MsgReactorBeginMigration } from "./types/structs/structs/tx";
import { MsgReactorBeginMigrationResponse } from "./types/structs/structs/tx";
import { MsgReactorCancelDefusion } from "./types/structs/structs/tx";
import { MsgReactorCancelDefusionResponse } from "./types/structs/structs/tx";
import { MsgReactorDefuse } from "./types/structs/structs/tx";
import { MsgReactorDefuseResponse } from "./types/structs/structs/tx";
import { MsgReactorInfuse } from "./types/structs/structs/tx";
import { MsgReactorInfuseResponse } from "./types/structs/structs/tx";
import { MsgReactorRestart } from "./types/structs/structs/tx";
import { MsgReactorRestartResponse } from "./types/structs/structs/tx";
import { MsgStructActivate } from "./types/structs/structs/tx";
import { MsgStructAttack } from "./types/structs/structs/tx";
import { MsgStructAttackResponse } from "./types/structs/structs/tx";
import { MsgStructBuildCancel } from "./types/structs/structs/tx";
import { MsgStructBuildComplete } from "./types/structs/structs/tx";
import { MsgStructBuildCompleteAndStash } from "./types/structs/structs/tx";
import { MsgStructBuildInitiate } from "./types/structs/structs/tx";
import { MsgStructDeactivate } from "./types/structs/structs/tx";
import { MsgStructDeactivateBatch } from "./types/structs/structs/tx";
import { MsgStructDeactivateBatchResponse } from "./types/structs/structs/tx";
import { MsgStructDefenseClear } from "./types/structs/structs/tx";
import { MsgStructDefenseSet } from "./types/structs/structs/tx";
import { MsgStructGeneratorInfuse } from "./types/structs/structs/tx";
import { MsgStructGeneratorStatusResponse } from "./types/structs/structs/tx";
import { MsgStructMove } from "./types/structs/structs/tx";
import { MsgStructOreMinerComplete } from "./types/structs/structs/tx";
import { MsgStructOreMinerStatusResponse } from "./types/structs/structs/tx";
import { MsgStructOreRefineryComplete } from "./types/structs/structs/tx";
import { MsgStructOreRefineryStatusResponse } from "./types/structs/structs/tx";
import { MsgStructStatusResponse } from "./types/structs/structs/tx";
import { MsgStructStealthActivate } from "./types/structs/structs/tx";
import { MsgStructStealthDeactivate } from "./types/structs/structs/tx";
import { MsgStructStorageRecall } from "./types/structs/structs/tx";
import { MsgStructStorageStash } from "./types/structs/structs/tx";
import { MsgStructTrash } from "./types/structs/structs/tx";
import { MsgSubstationAllocationConnect } from "./types/structs/structs/tx";
import { MsgSubstationAllocationConnectResponse } from "./types/structs/structs/tx";
import { MsgSubstationAllocationDisconnect } from "./types/structs/structs/tx";
import { MsgSubstationAllocationDisconnectResponse } from "./types/structs/structs/tx";
import { MsgSubstationCreate } from "./types/structs/structs/tx";
import { MsgSubstationCreateResponse } from "./types/structs/structs/tx";
import { MsgSubstationDelete } from "./types/structs/structs/tx";
import { MsgSubstationDeleteResponse } from "./types/structs/structs/tx";
import { MsgSubstationPlayerConnect } from "./types/structs/structs/tx";
import { MsgSubstationPlayerConnectResponse } from "./types/structs/structs/tx";
import { MsgSubstationPlayerDisconnect } from "./types/structs/structs/tx";
import { MsgSubstationPlayerDisconnectResponse } from "./types/structs/structs/tx";
import { MsgSubstationPlayerMigrate } from "./types/structs/structs/tx";
import { MsgSubstationPlayerMigrateResponse } from "./types/structs/structs/tx";
import { MsgSubstationUpdateName } from "./types/structs/structs/tx";
import { MsgSubstationUpdatePfp } from "./types/structs/structs/tx";
import { MsgSubstationUpdateResponse } from "./types/structs/structs/tx";
import { MsgUpdateParams } from "./types/structs/structs/tx";
import { MsgUpdateParamsResponse } from "./types/structs/structs/tx";
import { MsgVaultSend } from "./types/structs/structs/tx";
import { MsgVaultSendResponse } from "./types/structs/structs/tx";
import { NoData } from "./types/structs/structs/packet";
import { OwnerReactorDiversity } from "./types/structs/structs/reactor_diversity";
import { Params } from "./types/structs/structs/params";
import { PermissionRecord } from "./types/structs/structs/permission";
import { Planet } from "./types/structs/structs/planet";
import { PlanetAttributeRecord } from "./types/structs/structs/planet";
import { PlanetAttributes } from "./types/structs/structs/planet";
import { Player } from "./types/structs/structs/player";
import { PlayerInventory } from "./types/structs/structs/player";
import { Provider } from "./types/structs/structs/provider";
import { ProviderGuildAccessRecord } from "./types/structs/structs/provider";
import { QueryAddressResponse } from "./types/structs/structs/query";
import { QueryAllAddressByPlayerRequest } from "./types/structs/structs/query";
import { QueryAllAddressRequest } from "./types/structs/structs/query";
import { QueryAllAddressResponse } from "./types/structs/structs/query";
import { QueryAllAgreementByProviderRequest } from "./types/structs/structs/query";
import { QueryAllAgreementRequest } from "./types/structs/structs/query";
import { QueryAllAgreementResponse } from "./types/structs/structs/query";
import { QueryAllAllocationByDestinationRequest } from "./types/structs/structs/query";
import { QueryAllAllocationBySourceRequest } from "./types/structs/structs/query";
import { QueryAllAllocationRequest } from "./types/structs/structs/query";
import { QueryAllAllocationResponse } from "./types/structs/structs/query";
import { QueryAllFleetRequest } from "./types/structs/structs/query";
import { QueryAllFleetResponse } from "./types/structs/structs/query";
import { QueryAllGridRequest } from "./types/structs/structs/query";
import { QueryAllGridResponse } from "./types/structs/structs/query";
import { QueryAllGuildBankCollateralAddressRequest } from "./types/structs/structs/query";
import { QueryAllGuildBankCollateralAddressResponse } from "./types/structs/structs/query";
import { QueryAllGuildMembershipApplicationRequest } from "./types/structs/structs/query";
import { QueryAllGuildMembershipApplicationResponse } from "./types/structs/structs/query";
import { QueryAllGuildRequest } from "./types/structs/structs/query";
import { QueryAllGuildResponse } from "./types/structs/structs/query";
import { QueryAllInfusionByDestinationRequest } from "./types/structs/structs/query";
import { QueryAllInfusionRequest } from "./types/structs/structs/query";
import { QueryAllInfusionResponse } from "./types/structs/structs/query";
import { QueryAllPermissionByObjectRequest } from "./types/structs/structs/query";
import { QueryAllPermissionByPlayerRequest } from "./types/structs/structs/query";
import { QueryAllPermissionRequest } from "./types/structs/structs/query";
import { QueryAllPermissionResponse } from "./types/structs/structs/query";
import { QueryAllPlanetAttributeRequest } from "./types/structs/structs/query";
import { QueryAllPlanetAttributeResponse } from "./types/structs/structs/query";
import { QueryAllPlanetByPlayerRequest } from "./types/structs/structs/query";
import { QueryAllPlanetRequest } from "./types/structs/structs/query";
import { QueryAllPlanetResponse } from "./types/structs/structs/query";
import { QueryAllPlayerRequest } from "./types/structs/structs/query";
import { QueryAllPlayerResponse } from "./types/structs/structs/query";
import { QueryAllProviderCollateralAddressRequest } from "./types/structs/structs/query";
import { QueryAllProviderCollateralAddressResponse } from "./types/structs/structs/query";
import { QueryAllProviderEarningsAddressRequest } from "./types/structs/structs/query";
import { QueryAllProviderEarningsAddressResponse } from "./types/structs/structs/query";
import { QueryAllProviderRequest } from "./types/structs/structs/query";
import { QueryAllProviderResponse } from "./types/structs/structs/query";
import { QueryAllReactorRequest } from "./types/structs/structs/query";
import { QueryAllReactorResponse } from "./types/structs/structs/query";
import { QueryAllStructAttributeRequest } from "./types/structs/structs/query";
import { QueryAllStructAttributeResponse } from "./types/structs/structs/query";
import { QueryAllStructRequest } from "./types/structs/structs/query";
import { QueryAllStructResponse } from "./types/structs/structs/query";
import { QueryAllStructTypeRequest } from "./types/structs/structs/query";
import { QueryAllStructTypeResponse } from "./types/structs/structs/query";
import { QueryAllSubstationRequest } from "./types/structs/structs/query";
import { QueryAllSubstationResponse } from "./types/structs/structs/query";
import { QueryBlockHeight } from "./types/structs/structs/query";
import { QueryBlockHeightResponse } from "./types/structs/structs/query";
import { QueryGetAddressRequest } from "./types/structs/structs/query";
import { QueryGetAgreementRequest } from "./types/structs/structs/query";
import { QueryGetAgreementResponse } from "./types/structs/structs/query";
import { QueryGetAllocationRequest } from "./types/structs/structs/query";
import { QueryGetAllocationResponse } from "./types/structs/structs/query";
import { QueryGetFleetByIndexRequest } from "./types/structs/structs/query";
import { QueryGetFleetRequest } from "./types/structs/structs/query";
import { QueryGetFleetResponse } from "./types/structs/structs/query";
import { QueryGetGridRequest } from "./types/structs/structs/query";
import { QueryGetGridResponse } from "./types/structs/structs/query";
import { QueryGetGuildBankCollateralAddressRequest } from "./types/structs/structs/query";
import { QueryGetGuildByBankCollateralAddressRequest } from "./types/structs/structs/query";
import { QueryGetGuildMembershipApplicationRequest } from "./types/structs/structs/query";
import { QueryGetGuildMembershipApplicationResponse } from "./types/structs/structs/query";
import { QueryGetGuildRequest } from "./types/structs/structs/query";
import { QueryGetGuildResponse } from "./types/structs/structs/query";
import { QueryGetInfusionRequest } from "./types/structs/structs/query";
import { QueryGetInfusionResponse } from "./types/structs/structs/query";
import { QueryGetPermissionRequest } from "./types/structs/structs/query";
import { QueryGetPermissionResponse } from "./types/structs/structs/query";
import { QueryGetPlanetAttributeRequest } from "./types/structs/structs/query";
import { QueryGetPlanetAttributeResponse } from "./types/structs/structs/query";
import { QueryGetPlanetRequest } from "./types/structs/structs/query";
import { QueryGetPlanetResponse } from "./types/structs/structs/query";
import { QueryGetPlayerRequest } from "./types/structs/structs/query";
import { QueryGetPlayerResponse } from "./types/structs/structs/query";
import { QueryGetProviderByCollateralAddressRequest } from "./types/structs/structs/query";
import { QueryGetProviderByEarningsAddressRequest } from "./types/structs/structs/query";
import { QueryGetProviderCollateralAddressRequest } from "./types/structs/structs/query";
import { QueryGetProviderEarningsAddressRequest } from "./types/structs/structs/query";
import { QueryGetProviderRequest } from "./types/structs/structs/query";
import { QueryGetProviderResponse } from "./types/structs/structs/query";
import { QueryGetReactorRequest } from "./types/structs/structs/query";
import { QueryGetReactorResponse } from "./types/structs/structs/query";
import { QueryGetStructAttributeRequest } from "./types/structs/structs/query";
import { QueryGetStructAttributeResponse } from "./types/structs/structs/query";
import { QueryGetStructRequest } from "./types/structs/structs/query";
import { QueryGetStructResponse } from "./types/structs/structs/query";
import { QueryGetStructTypeRequest } from "./types/structs/structs/query";
import { QueryGetStructTypeResponse } from "./types/structs/structs/query";
import { QueryGetSubstationRequest } from "./types/structs/structs/query";
import { QueryGetSubstationResponse } from "./types/structs/structs/query";
import { QueryGuildCharter } from "./types/structs/structs/query";
import { QueryGuildCharterResponse } from "./types/structs/structs/query";
import { QueryGuildRankPermissionByObjectAndGuildRequest } from "./types/structs/structs/query";
import { QueryGuildRankPermissionByObjectAndGuildResponse } from "./types/structs/structs/query";
import { QueryGuildRankPermissionByObjectRequest } from "./types/structs/structs/query";
import { QueryGuildRankPermissionByObjectResponse } from "./types/structs/structs/query";
import { QueryOwnerReactorDiversityRequest } from "./types/structs/structs/query";
import { QueryOwnerReactorDiversityResponse } from "./types/structs/structs/query";
import { QueryParamsRequest } from "./types/structs/structs/query";
import { QueryParamsResponse } from "./types/structs/structs/query";
import { QueryReactorStakeShareRequest } from "./types/structs/structs/query";
import { QueryReactorStakeShareResponse } from "./types/structs/structs/query";
import { QueryValidateSignatureRequest } from "./types/structs/structs/query";
import { QueryValidateSignatureResponse } from "./types/structs/structs/query";
import { QueryVaultRequest } from "./types/structs/structs/query";
import { QueryVaultResponse } from "./types/structs/structs/query";
import { Reactor } from "./types/structs/structs/reactor";
import { ReactorDiversityPosition } from "./types/structs/structs/reactor_diversity";
import { Struct } from "./types/structs/structs/struct";
import { StructAttributeRecord } from "./types/structs/structs/struct";
import { StructAttributes } from "./types/structs/structs/struct";
import { StructDefender } from "./types/structs/structs/struct";
import { StructDefenders } from "./types/structs/structs/struct";
import { StructDestructionQueueRecord } from "./types/structs/structs/struct";
import { StructType } from "./types/structs/structs/struct";
import { StructsPacketData } from "./types/structs/structs/packet";
import { Substation } from "./types/structs/structs/substation";
import { VaultVestingAccount } from "./types/structs/structs/vault_vesting";
import { VaultVestingSchedule } from "./types/structs/structs/vault_vesting";

export const msgTypes: Array<[string, GeneratedType]> = [
  ["/structs.structs.AddressActivity", AddressActivity],
  ["/structs.structs.AddressAssociation", AddressAssociation],
  ["/structs.structs.AddressNonceRecord", AddressNonceRecord],
  ["/structs.structs.AddressRecord", AddressRecord],
  ["/structs.structs.Agreement", Agreement],
  ["/structs.structs.Allocation", Allocation],
  ["/structs.structs.EventAddressActivity", EventAddressActivity],
  ["/structs.structs.EventAddressAssociation", EventAddressAssociation],
  ["/structs.structs.EventAgreement", EventAgreement],
  ["/structs.structs.EventAllocation", EventAllocation],
  ["/structs.structs.EventAlphaDefuse", EventAlphaDefuse],
  ["/structs.structs.EventAlphaDefuseDetail", EventAlphaDefuseDetail],
  ["/structs.structs.EventAlphaInfuse", EventAlphaInfuse],
  ["/structs.structs.EventAlphaInfuseDetail", EventAlphaInfuseDetail],
  ["/structs.structs.EventAlphaRefine", EventAlphaRefine],
  ["/structs.structs.EventAlphaRefineDetail", EventAlphaRefineDetail],
  ["/structs.structs.EventAttack", EventAttack],
  ["/structs.structs.EventAttackDefenderCounterDetail", EventAttackDefenderCounterDetail],
  ["/structs.structs.EventAttackDetail", EventAttackDetail],
  ["/structs.structs.EventAttackShotDetail", EventAttackShotDetail],
  ["/structs.structs.EventDelete", EventDelete],
  ["/structs.structs.EventFleet", EventFleet],
  ["/structs.structs.EventGrid", EventGrid],
  ["/structs.structs.EventGuild", EventGuild],
  ["/structs.structs.EventGuildBankAddress", EventGuildBankAddress],
  ["/structs.structs.EventGuildBankAddressDetail", EventGuildBankAddressDetail],
  ["/structs.structs.EventGuildBankConfiscateAndBurn", EventGuildBankConfiscateAndBurn],
  ["/structs.structs.EventGuildBankConfiscateAndBurnDetail", EventGuildBankConfiscateAndBurnDetail],
  ["/structs.structs.EventGuildBankConvert", EventGuildBankConvert],
  ["/structs.structs.EventGuildBankConvertDetail", EventGuildBankConvertDetail],
  ["/structs.structs.EventGuildBankConvertToken", EventGuildBankConvertToken],
  ["/structs.structs.EventGuildBankConvertTokenDetail", EventGuildBankConvertTokenDetail],
  ["/structs.structs.EventGuildBankMint", EventGuildBankMint],
  ["/structs.structs.EventGuildBankMintDetail", EventGuildBankMintDetail],
  ["/structs.structs.EventGuildBankRedeem", EventGuildBankRedeem],
  ["/structs.structs.EventGuildBankRedeemDetail", EventGuildBankRedeemDetail],
  ["/structs.structs.EventGuildMembershipApplication", EventGuildMembershipApplication],
  ["/structs.structs.EventGuildRankPermission", EventGuildRankPermission],
  ["/structs.structs.EventGuildRankPurchase", EventGuildRankPurchase],
  ["/structs.structs.EventHashSuccess", EventHashSuccess],
  ["/structs.structs.EventHashSuccessDetail", EventHashSuccessDetail],
  ["/structs.structs.EventInfusion", EventInfusion],
  ["/structs.structs.EventOreMigrate", EventOreMigrate],
  ["/structs.structs.EventOreMigrateDetail", EventOreMigrateDetail],
  ["/structs.structs.EventOreMine", EventOreMine],
  ["/structs.structs.EventOreMineDetail", EventOreMineDetail],
  ["/structs.structs.EventOreTheft", EventOreTheft],
  ["/structs.structs.EventOreTheftDetail", EventOreTheftDetail],
  ["/structs.structs.EventOwnerReactorDiversity", EventOwnerReactorDiversity],
  ["/structs.structs.EventOwnerReactorDiversityReset", EventOwnerReactorDiversityReset],
  ["/structs.structs.EventPermission", EventPermission],
  ["/structs.structs.EventPlanet", EventPlanet],
  ["/structs.structs.EventPlanetAttribute", EventPlanetAttribute],
  ["/structs.structs.EventPlayer", EventPlayer],
  ["/structs.structs.EventPlayerHalted", EventPlayerHalted],
  ["/structs.structs.EventPlayerResumed", EventPlayerResumed],
  ["/structs.structs.EventProvider", EventProvider],
  ["/structs.structs.EventProviderAddress", EventProviderAddress],
  ["/structs.structs.EventProviderAddressDetail", EventProviderAddressDetail],
  ["/structs.structs.EventProviderGrantGuild", EventProviderGrantGuild],
  ["/structs.structs.EventProviderGrantGuildDetail", EventProviderGrantGuildDetail],
  ["/structs.structs.EventProviderRevenueShortfall", EventProviderRevenueShortfall],
  ["/structs.structs.EventProviderRevenueShortfallDetail", EventProviderRevenueShortfallDetail],
  ["/structs.structs.EventProviderRevokeGuild", EventProviderRevokeGuild],
  ["/structs.structs.EventProviderRevokeGuildDetail", EventProviderRevokeGuildDetail],
  ["/structs.structs.EventRaid", EventRaid],
  ["/structs.structs.EventRaidDetail", EventRaidDetail],
  ["/structs.structs.EventReactor", EventReactor],
  ["/structs.structs.EventReactorCommissionRevision", EventReactorCommissionRevision],
  ["/structs.structs.EventReactorCommissionRevisionReset", EventReactorCommissionRevisionReset],
  ["/structs.structs.EventReactorStakeCap", EventReactorStakeCap],
  ["/structs.structs.EventStruct", EventStruct],
  ["/structs.structs.EventStructAttribute", EventStructAttribute],
  ["/structs.structs.EventStructDefender", EventStructDefender],
  ["/structs.structs.EventStructDefenderClear", EventStructDefenderClear],
  ["/structs.structs.EventStructDefenderClearDetail", EventStructDefenderClearDetail],
  ["/structs.structs.EventStructType", EventStructType],
  ["/structs.structs.EventSubstation", EventSubstation],
  ["/structs.structs.EventTime", EventTime],
  ["/structs.structs.EventTimeDetail", EventTimeDetail],
  ["/structs.structs.EventVaultAddress", EventVaultAddress],
  ["/structs.structs.EventVaultAddressDetail", EventVaultAddressDetail],
  ["/structs.structs.EventVaultDelegationMigration", EventVaultDelegationMigration],
  ["/structs.structs.EventVaultRedelegationMigration", EventVaultRedelegationMigration],
  ["/structs.structs.EventVaultUnbondingMigration", EventVaultUnbondingMigration],
  ["/structs.structs.EventVaultVestingMigration", EventVaultVestingMigration],
  ["/structs.structs.Fleet", Fleet],
  ["/structs.structs.FleetAttributeRecord", FleetAttributeRecord],
  ["/structs.structs.GenesisState", GenesisState],
  ["/structs.structs.GridAttributes", GridAttributes],
  ["/structs.structs.GridRecord", GridRecord],
  ["/structs.structs.Guild", Guild],
  ["/structs.structs.GuildMembershipApplication", GuildMembershipApplication],
  ["/structs.structs.GuildRankPermissionRecord", GuildRankPermissionRecord],
  ["/structs.structs.Infusion", Infusion],
  ["/structs.structs.InternalAddressAssociation", InternalAddressAssociation],
  ["/structs.structs.MsgAddressRegister", MsgAddressRegister],
  ["/structs.structs.MsgAddressRegisterResponse", MsgAddressRegisterResponse],
  ["/structs.structs.MsgAddressRevoke", MsgAddressRevoke],
  ["/structs.structs.MsgAddressRevokeResponse", MsgAddressRevokeResponse],
  ["/structs.structs.MsgAgreementCapacityDecrease", MsgAgreementCapacityDecrease],
  ["/structs.structs.MsgAgreementCapacityIncrease", MsgAgreementCapacityIncrease],
  ["/structs.structs.MsgAgreementClose", MsgAgreementClose],
  ["/structs.structs.MsgAgreementDurationIncrease", MsgAgreementDurationIncrease],
  ["/structs.structs.MsgAgreementOpen", MsgAgreementOpen],
  ["/structs.structs.MsgAgreementResponse", MsgAgreementResponse],
  ["/structs.structs.MsgAllocationCreate", MsgAllocationCreate],
  ["/structs.structs.MsgAllocationCreateResponse", MsgAllocationCreateResponse],
  ["/structs.structs.MsgAllocationDelete", MsgAllocationDelete],
  ["/structs.structs.MsgAllocationDeleteResponse", MsgAllocationDeleteResponse],
  ["/structs.structs.MsgAllocationTransfer", MsgAllocationTransfer],
  ["/structs.structs.MsgAllocationTransferResponse", MsgAllocationTransferResponse],
  ["/structs.structs.MsgAllocationUpdate", MsgAllocationUpdate],
  ["/structs.structs.MsgAllocationUpdateResponse", MsgAllocationUpdateResponse],
  ["/structs.structs.MsgFleetMove", MsgFleetMove],
  ["/structs.structs.MsgFleetMoveResponse", MsgFleetMoveResponse],
  ["/structs.structs.MsgGuildBankConfiscateAndBurn", MsgGuildBankConfiscateAndBurn],
  ["/structs.structs.MsgGuildBankConfiscateAndBurnResponse", MsgGuildBankConfiscateAndBurnResponse],
  ["/structs.structs.MsgGuildBankConvert", MsgGuildBankConvert],
  ["/structs.structs.MsgGuildBankConvertResponse", MsgGuildBankConvertResponse],
  ["/structs.structs.MsgGuildBankConvertToken", MsgGuildBankConvertToken],
  ["/structs.structs.MsgGuildBankConvertTokenResponse", MsgGuildBankConvertTokenResponse],
  ["/structs.structs.MsgGuildBankMint", MsgGuildBankMint],
  ["/structs.structs.MsgGuildBankMintResponse", MsgGuildBankMintResponse],
  ["/structs.structs.MsgGuildBankRedeem", MsgGuildBankRedeem],
  ["/structs.structs.MsgGuildBankRedeemResponse", MsgGuildBankRedeemResponse],
  ["/structs.structs.MsgGuildCreate", MsgGuildCreate],
  ["/structs.structs.MsgGuildCreateResponse", MsgGuildCreateResponse],
  ["/structs.structs.MsgGuildMembershipInvite", MsgGuildMembershipInvite],
  ["/structs.structs.MsgGuildMembershipInviteApprove", MsgGuildMembershipInviteApprove],
  ["/structs.structs.MsgGuildMembershipInviteDeny", MsgGuildMembershipInviteDeny],
  ["/structs.structs.MsgGuildMembershipInviteRevoke", MsgGuildMembershipInviteRevoke],
  ["/structs.structs.MsgGuildMembershipJoin", MsgGuildMembershipJoin],
  ["/structs.structs.MsgGuildMembershipJoinByRankPurchase", MsgGuildMembershipJoinByRankPurchase],
  ["/structs.structs.MsgGuildMembershipJoinProxy", MsgGuildMembershipJoinProxy],
  ["/structs.structs.MsgGuildMembershipKick", MsgGuildMembershipKick],
  ["/structs.structs.MsgGuildMembershipRequest", MsgGuildMembershipRequest],
  ["/structs.structs.MsgGuildMembershipRequestApprove", MsgGuildMembershipRequestApprove],
  ["/structs.structs.MsgGuildMembershipRequestDeny", MsgGuildMembershipRequestDeny],
  ["/structs.structs.MsgGuildMembershipRequestRevoke", MsgGuildMembershipRequestRevoke],
  ["/structs.structs.MsgGuildMembershipResponse", MsgGuildMembershipResponse],
  ["/structs.structs.MsgGuildRankPurchase", MsgGuildRankPurchase],
  ["/structs.structs.MsgGuildRankPurchaseResponse", MsgGuildRankPurchaseResponse],
  ["/structs.structs.MsgGuildUpdateBankConvertInFee", MsgGuildUpdateBankConvertInFee],
  ["/structs.structs.MsgGuildUpdateBankConvertOutFee", MsgGuildUpdateBankConvertOutFee],
  ["/structs.structs.MsgGuildUpdateEndpoint", MsgGuildUpdateEndpoint],
  ["/structs.structs.MsgGuildUpdateEntryRank", MsgGuildUpdateEntryRank],
  ["/structs.structs.MsgGuildUpdateEntrySubstationId", MsgGuildUpdateEntrySubstationId],
  ["/structs.structs.MsgGuildUpdateJoinInfusionMinimum", MsgGuildUpdateJoinInfusionMinimum],
  ["/structs.structs.MsgGuildUpdateJoinInfusionMinimumBypassByInvite", MsgGuildUpdateJoinInfusionMinimumBypassByInvite],
  ["/structs.structs.MsgGuildUpdateJoinInfusionMinimumBypassByRequest", MsgGuildUpdateJoinInfusionMinimumBypassByRequest],
  ["/structs.structs.MsgGuildUpdateName", MsgGuildUpdateName],
  ["/structs.structs.MsgGuildUpdateOwnerId", MsgGuildUpdateOwnerId],
  ["/structs.structs.MsgGuildUpdatePfp", MsgGuildUpdatePfp],
  ["/structs.structs.MsgGuildUpdatePrimaryReactor", MsgGuildUpdatePrimaryReactor],
  ["/structs.structs.MsgGuildUpdateRankPurchase", MsgGuildUpdateRankPurchase],
  ["/structs.structs.MsgGuildUpdateResponse", MsgGuildUpdateResponse],
  ["/structs.structs.MsgPermissionGrantOnAddress", MsgPermissionGrantOnAddress],
  ["/structs.structs.MsgPermissionGrantOnObject", MsgPermissionGrantOnObject],
  ["/structs.structs.MsgPermissionGuildRankRevoke", MsgPermissionGuildRankRevoke],
  ["/structs.structs.MsgPermissionGuildRankSet", MsgPermissionGuildRankSet],
  ["/structs.structs.MsgPermissionResponse", MsgPermissionResponse],
  ["/structs.structs.MsgPermissionRevokeOnAddress", MsgPermissionRevokeOnAddress],
  ["/structs.structs.MsgPermissionRevokeOnObject", MsgPermissionRevokeOnObject],
  ["/structs.structs.MsgPermissionSetOnAddress", MsgPermissionSetOnAddress],
  ["/structs.structs.MsgPermissionSetOnObject", MsgPermissionSetOnObject],
  ["/structs.structs.MsgPlanetExplore", MsgPlanetExplore],
  ["/structs.structs.MsgPlanetExploreResponse", MsgPlanetExploreResponse],
  ["/structs.structs.MsgPlanetRaidComplete", MsgPlanetRaidComplete],
  ["/structs.structs.MsgPlanetRaidCompleteResponse", MsgPlanetRaidCompleteResponse],
  ["/structs.structs.MsgPlanetUpdateName", MsgPlanetUpdateName],
  ["/structs.structs.MsgPlanetUpdateResponse", MsgPlanetUpdateResponse],
  ["/structs.structs.MsgPlayerResume", MsgPlayerResume],
  ["/structs.structs.MsgPlayerResumeResponse", MsgPlayerResumeResponse],
  ["/structs.structs.MsgPlayerSend", MsgPlayerSend],
  ["/structs.structs.MsgPlayerSendResponse", MsgPlayerSendResponse],
  ["/structs.structs.MsgPlayerUpdateGuildRank", MsgPlayerUpdateGuildRank],
  ["/structs.structs.MsgPlayerUpdateGuildRankResponse", MsgPlayerUpdateGuildRankResponse],
  ["/structs.structs.MsgPlayerUpdateName", MsgPlayerUpdateName],
  ["/structs.structs.MsgPlayerUpdatePfp", MsgPlayerUpdatePfp],
  ["/structs.structs.MsgPlayerUpdatePfpClientRenderAttributes", MsgPlayerUpdatePfpClientRenderAttributes],
  ["/structs.structs.MsgPlayerUpdatePrimaryAddress", MsgPlayerUpdatePrimaryAddress],
  ["/structs.structs.MsgPlayerUpdatePrimaryAddressResponse", MsgPlayerUpdatePrimaryAddressResponse],
  ["/structs.structs.MsgPlayerUpdateResponse", MsgPlayerUpdateResponse],
  ["/structs.structs.MsgProviderCreate", MsgProviderCreate],
  ["/structs.structs.MsgProviderDelete", MsgProviderDelete],
  ["/structs.structs.MsgProviderResponse", MsgProviderResponse],
  ["/structs.structs.MsgProviderUpdateAccessPolicy", MsgProviderUpdateAccessPolicy],
  ["/structs.structs.MsgProviderUpdateCapacityMaximum", MsgProviderUpdateCapacityMaximum],
  ["/structs.structs.MsgProviderUpdateCapacityMinimum", MsgProviderUpdateCapacityMinimum],
  ["/structs.structs.MsgProviderUpdateDurationMaximum", MsgProviderUpdateDurationMaximum],
  ["/structs.structs.MsgProviderUpdateDurationMinimum", MsgProviderUpdateDurationMinimum],
  ["/structs.structs.MsgProviderWithdrawBalance", MsgProviderWithdrawBalance],
  ["/structs.structs.MsgReactorBeginMigration", MsgReactorBeginMigration],
  ["/structs.structs.MsgReactorBeginMigrationResponse", MsgReactorBeginMigrationResponse],
  ["/structs.structs.MsgReactorCancelDefusion", MsgReactorCancelDefusion],
  ["/structs.structs.MsgReactorCancelDefusionResponse", MsgReactorCancelDefusionResponse],
  ["/structs.structs.MsgReactorDefuse", MsgReactorDefuse],
  ["/structs.structs.MsgReactorDefuseResponse", MsgReactorDefuseResponse],
  ["/structs.structs.MsgReactorInfuse", MsgReactorInfuse],
  ["/structs.structs.MsgReactorInfuseResponse", MsgReactorInfuseResponse],
  ["/structs.structs.MsgReactorRestart", MsgReactorRestart],
  ["/structs.structs.MsgReactorRestartResponse", MsgReactorRestartResponse],
  ["/structs.structs.MsgStructActivate", MsgStructActivate],
  ["/structs.structs.MsgStructAttack", MsgStructAttack],
  ["/structs.structs.MsgStructAttackResponse", MsgStructAttackResponse],
  ["/structs.structs.MsgStructBuildCancel", MsgStructBuildCancel],
  ["/structs.structs.MsgStructBuildComplete", MsgStructBuildComplete],
  ["/structs.structs.MsgStructBuildCompleteAndStash", MsgStructBuildCompleteAndStash],
  ["/structs.structs.MsgStructBuildInitiate", MsgStructBuildInitiate],
  ["/structs.structs.MsgStructDeactivate", MsgStructDeactivate],
  ["/structs.structs.MsgStructDeactivateBatch", MsgStructDeactivateBatch],
  ["/structs.structs.MsgStructDeactivateBatchResponse", MsgStructDeactivateBatchResponse],
  ["/structs.structs.MsgStructDefenseClear", MsgStructDefenseClear],
  ["/structs.structs.MsgStructDefenseSet", MsgStructDefenseSet],
  ["/structs.structs.MsgStructGeneratorInfuse", MsgStructGeneratorInfuse],
  ["/structs.structs.MsgStructGeneratorStatusResponse", MsgStructGeneratorStatusResponse],
  ["/structs.structs.MsgStructMove", MsgStructMove],
  ["/structs.structs.MsgStructOreMinerComplete", MsgStructOreMinerComplete],
  ["/structs.structs.MsgStructOreMinerStatusResponse", MsgStructOreMinerStatusResponse],
  ["/structs.structs.MsgStructOreRefineryComplete", MsgStructOreRefineryComplete],
  ["/structs.structs.MsgStructOreRefineryStatusResponse", MsgStructOreRefineryStatusResponse],
  ["/structs.structs.MsgStructStatusResponse", MsgStructStatusResponse],
  ["/structs.structs.MsgStructStealthActivate", MsgStructStealthActivate],
  ["/structs.structs.MsgStructStealthDeactivate", MsgStructStealthDeactivate],
  ["/structs.structs.MsgStructStorageRecall", MsgStructStorageRecall],
  ["/structs.structs.MsgStructStorageStash", MsgStructStorageStash],
  ["/structs.structs.MsgStructTrash", MsgStructTrash],
  ["/structs.structs.MsgSubstationAllocationConnect", MsgSubstationAllocationConnect],
  ["/structs.structs.MsgSubstationAllocationConnectResponse", MsgSubstationAllocationConnectResponse],
  ["/structs.structs.MsgSubstationAllocationDisconnect", MsgSubstationAllocationDisconnect],
  ["/structs.structs.MsgSubstationAllocationDisconnectResponse", MsgSubstationAllocationDisconnectResponse],
  ["/structs.structs.MsgSubstationCreate", MsgSubstationCreate],
  ["/structs.structs.MsgSubstationCreateResponse", MsgSubstationCreateResponse],
  ["/structs.structs.MsgSubstationDelete", MsgSubstationDelete],
  ["/structs.structs.MsgSubstationDeleteResponse", MsgSubstationDeleteResponse],
  ["/structs.structs.MsgSubstationPlayerConnect", MsgSubstationPlayerConnect],
  ["/structs.structs.MsgSubstationPlayerConnectResponse", MsgSubstationPlayerConnectResponse],
  ["/structs.structs.MsgSubstationPlayerDisconnect", MsgSubstationPlayerDisconnect],
  ["/structs.structs.MsgSubstationPlayerDisconnectResponse", MsgSubstationPlayerDisconnectResponse],
  ["/structs.structs.MsgSubstationPlayerMigrate", MsgSubstationPlayerMigrate],
  ["/structs.structs.MsgSubstationPlayerMigrateResponse", MsgSubstationPlayerMigrateResponse],
  ["/structs.structs.MsgSubstationUpdateName", MsgSubstationUpdateName],
  ["/structs.structs.MsgSubstationUpdatePfp", MsgSubstationUpdatePfp],
  ["/structs.structs.MsgSubstationUpdateResponse", MsgSubstationUpdateResponse],
  ["/structs.structs.MsgUpdateParams", MsgUpdateParams],
  ["/structs.structs.MsgUpdateParamsResponse", MsgUpdateParamsResponse],
  ["/structs.structs.MsgVaultSend", MsgVaultSend],
  ["/structs.structs.MsgVaultSendResponse", MsgVaultSendResponse],
  ["/structs.structs.NoData", NoData],
  ["/structs.structs.OwnerReactorDiversity", OwnerReactorDiversity],
  ["/structs.structs.Params", Params],
  ["/structs.structs.PermissionRecord", PermissionRecord],
  ["/structs.structs.Planet", Planet],
  ["/structs.structs.PlanetAttributeRecord", PlanetAttributeRecord],
  ["/structs.structs.PlanetAttributes", PlanetAttributes],
  ["/structs.structs.Player", Player],
  ["/structs.structs.PlayerInventory", PlayerInventory],
  ["/structs.structs.Provider", Provider],
  ["/structs.structs.ProviderGuildAccessRecord", ProviderGuildAccessRecord],
  ["/structs.structs.QueryAddressResponse", QueryAddressResponse],
  ["/structs.structs.QueryAllAddressByPlayerRequest", QueryAllAddressByPlayerRequest],
  ["/structs.structs.QueryAllAddressRequest", QueryAllAddressRequest],
  ["/structs.structs.QueryAllAddressResponse", QueryAllAddressResponse],
  ["/structs.structs.QueryAllAgreementByProviderRequest", QueryAllAgreementByProviderRequest],
  ["/structs.structs.QueryAllAgreementRequest", QueryAllAgreementRequest],
  ["/structs.structs.QueryAllAgreementResponse", QueryAllAgreementResponse],
  ["/structs.structs.QueryAllAllocationByDestinationRequest", QueryAllAllocationByDestinationRequest],
  ["/structs.structs.QueryAllAllocationBySourceRequest", QueryAllAllocationBySourceRequest],
  ["/structs.structs.QueryAllAllocationRequest", QueryAllAllocationRequest],
  ["/structs.structs.QueryAllAllocationResponse", QueryAllAllocationResponse],
  ["/structs.structs.QueryAllFleetRequest", QueryAllFleetRequest],
  ["/structs.structs.QueryAllFleetResponse", QueryAllFleetResponse],
  ["/structs.structs.QueryAllGridRequest", QueryAllGridRequest],
  ["/structs.structs.QueryAllGridResponse", QueryAllGridResponse],
  ["/structs.structs.QueryAllGuildBankCollateralAddressRequest", QueryAllGuildBankCollateralAddressRequest],
  ["/structs.structs.QueryAllGuildBankCollateralAddressResponse", QueryAllGuildBankCollateralAddressResponse],
  ["/structs.structs.QueryAllGuildMembershipApplicationRequest", QueryAllGuildMembershipApplicationRequest],
  ["/structs.structs.QueryAllGuildMembershipApplicationResponse", QueryAllGuildMembershipApplicationResponse],
  ["/structs.structs.QueryAllGuildRequest", QueryAllGuildRequest],
  ["/structs.structs.QueryAllGuildResponse", QueryAllGuildResponse],
  ["/structs.structs.QueryAllInfusionByDestinationRequest", QueryAllInfusionByDestinationRequest],
  ["/structs.structs.QueryAllInfusionRequest", QueryAllInfusionRequest],
  ["/structs.structs.QueryAllInfusionResponse", QueryAllInfusionResponse],
  ["/structs.structs.QueryAllPermissionByObjectRequest", QueryAllPermissionByObjectRequest],
  ["/structs.structs.QueryAllPermissionByPlayerRequest", QueryAllPermissionByPlayerRequest],
  ["/structs.structs.QueryAllPermissionRequest", QueryAllPermissionRequest],
  ["/structs.structs.QueryAllPermissionResponse", QueryAllPermissionResponse],
  ["/structs.structs.QueryAllPlanetAttributeRequest", QueryAllPlanetAttributeRequest],
  ["/structs.structs.QueryAllPlanetAttributeResponse", QueryAllPlanetAttributeResponse],
  ["/structs.structs.QueryAllPlanetByPlayerRequest", QueryAllPlanetByPlayerRequest],
  ["/structs.structs.QueryAllPlanetRequest", QueryAllPlanetRequest],
  ["/structs.structs.QueryAllPlanetResponse", QueryAllPlanetResponse],
  ["/structs.structs.QueryAllPlayerRequest", QueryAllPlayerRequest],
  ["/structs.structs.QueryAllPlayerResponse", QueryAllPlayerResponse],
  ["/structs.structs.QueryAllProviderCollateralAddressRequest", QueryAllProviderCollateralAddressRequest],
  ["/structs.structs.QueryAllProviderCollateralAddressResponse", QueryAllProviderCollateralAddressResponse],
  ["/structs.structs.QueryAllProviderEarningsAddressRequest", QueryAllProviderEarningsAddressRequest],
  ["/structs.structs.QueryAllProviderEarningsAddressResponse", QueryAllProviderEarningsAddressResponse],
  ["/structs.structs.QueryAllProviderRequest", QueryAllProviderRequest],
  ["/structs.structs.QueryAllProviderResponse", QueryAllProviderResponse],
  ["/structs.structs.QueryAllReactorRequest", QueryAllReactorRequest],
  ["/structs.structs.QueryAllReactorResponse", QueryAllReactorResponse],
  ["/structs.structs.QueryAllStructAttributeRequest", QueryAllStructAttributeRequest],
  ["/structs.structs.QueryAllStructAttributeResponse", QueryAllStructAttributeResponse],
  ["/structs.structs.QueryAllStructRequest", QueryAllStructRequest],
  ["/structs.structs.QueryAllStructResponse", QueryAllStructResponse],
  ["/structs.structs.QueryAllStructTypeRequest", QueryAllStructTypeRequest],
  ["/structs.structs.QueryAllStructTypeResponse", QueryAllStructTypeResponse],
  ["/structs.structs.QueryAllSubstationRequest", QueryAllSubstationRequest],
  ["/structs.structs.QueryAllSubstationResponse", QueryAllSubstationResponse],
  ["/structs.structs.QueryBlockHeight", QueryBlockHeight],
  ["/structs.structs.QueryBlockHeightResponse", QueryBlockHeightResponse],
  ["/structs.structs.QueryGetAddressRequest", QueryGetAddressRequest],
  ["/structs.structs.QueryGetAgreementRequest", QueryGetAgreementRequest],
  ["/structs.structs.QueryGetAgreementResponse", QueryGetAgreementResponse],
  ["/structs.structs.QueryGetAllocationRequest", QueryGetAllocationRequest],
  ["/structs.structs.QueryGetAllocationResponse", QueryGetAllocationResponse],
  ["/structs.structs.QueryGetFleetByIndexRequest", QueryGetFleetByIndexRequest],
  ["/structs.structs.QueryGetFleetRequest", QueryGetFleetRequest],
  ["/structs.structs.QueryGetFleetResponse", QueryGetFleetResponse],
  ["/structs.structs.QueryGetGridRequest", QueryGetGridRequest],
  ["/structs.structs.QueryGetGridResponse", QueryGetGridResponse],
  ["/structs.structs.QueryGetGuildBankCollateralAddressRequest", QueryGetGuildBankCollateralAddressRequest],
  ["/structs.structs.QueryGetGuildByBankCollateralAddressRequest", QueryGetGuildByBankCollateralAddressRequest],
  ["/structs.structs.QueryGetGuildMembershipApplicationRequest", QueryGetGuildMembershipApplicationRequest],
  ["/structs.structs.QueryGetGuildMembershipApplicationResponse", QueryGetGuildMembershipApplicationResponse],
  ["/structs.structs.QueryGetGuildRequest", QueryGetGuildRequest],
  ["/structs.structs.QueryGetGuildResponse", QueryGetGuildResponse],
  ["/structs.structs.QueryGetInfusionRequest", QueryGetInfusionRequest],
  ["/structs.structs.QueryGetInfusionResponse", QueryGetInfusionResponse],
  ["/structs.structs.QueryGetPermissionRequest", QueryGetPermissionRequest],
  ["/structs.structs.QueryGetPermissionResponse", QueryGetPermissionResponse],
  ["/structs.structs.QueryGetPlanetAttributeRequest", QueryGetPlanetAttributeRequest],
  ["/structs.structs.QueryGetPlanetAttributeResponse", QueryGetPlanetAttributeResponse],
  ["/structs.structs.QueryGetPlanetRequest", QueryGetPlanetRequest],
  ["/structs.structs.QueryGetPlanetResponse", QueryGetPlanetResponse],
  ["/structs.structs.QueryGetPlayerRequest", QueryGetPlayerRequest],
  ["/structs.structs.QueryGetPlayerResponse", QueryGetPlayerResponse],
  ["/structs.structs.QueryGetProviderByCollateralAddressRequest", QueryGetProviderByCollateralAddressRequest],
  ["/structs.structs.QueryGetProviderByEarningsAddressRequest", QueryGetProviderByEarningsAddressRequest],
  ["/structs.structs.QueryGetProviderCollateralAddressRequest", QueryGetProviderCollateralAddressRequest],
  ["/structs.structs.QueryGetProviderEarningsAddressRequest", QueryGetProviderEarningsAddressRequest],
  ["/structs.structs.QueryGetProviderRequest", QueryGetProviderRequest],
  ["/structs.structs.QueryGetProviderResponse", QueryGetProviderResponse],
  ["/structs.structs.QueryGetReactorRequest", QueryGetReactorRequest],
  ["/structs.structs.QueryGetReactorResponse", QueryGetReactorResponse],
  ["/structs.structs.QueryGetStructAttributeRequest", QueryGetStructAttributeRequest],
  ["/structs.structs.QueryGetStructAttributeResponse", QueryGetStructAttributeResponse],
  ["/structs.structs.QueryGetStructRequest", QueryGetStructRequest],
  ["/structs.structs.QueryGetStructResponse", QueryGetStructResponse],
  ["/structs.structs.QueryGetStructTypeRequest", QueryGetStructTypeRequest],
  ["/structs.structs.QueryGetStructTypeResponse", QueryGetStructTypeResponse],
  ["/structs.structs.QueryGetSubstationRequest", QueryGetSubstationRequest],
  ["/structs.structs.QueryGetSubstationResponse", QueryGetSubstationResponse],
  ["/structs.structs.QueryGuildCharter", QueryGuildCharter],
  ["/structs.structs.QueryGuildCharterResponse", QueryGuildCharterResponse],
  ["/structs.structs.QueryGuildRankPermissionByObjectAndGuildRequest", QueryGuildRankPermissionByObjectAndGuildRequest],
  ["/structs.structs.QueryGuildRankPermissionByObjectAndGuildResponse", QueryGuildRankPermissionByObjectAndGuildResponse],
  ["/structs.structs.QueryGuildRankPermissionByObjectRequest", QueryGuildRankPermissionByObjectRequest],
  ["/structs.structs.QueryGuildRankPermissionByObjectResponse", QueryGuildRankPermissionByObjectResponse],
  ["/structs.structs.QueryOwnerReactorDiversityRequest", QueryOwnerReactorDiversityRequest],
  ["/structs.structs.QueryOwnerReactorDiversityResponse", QueryOwnerReactorDiversityResponse],
  ["/structs.structs.QueryParamsRequest", QueryParamsRequest],
  ["/structs.structs.QueryParamsResponse", QueryParamsResponse],
  ["/structs.structs.QueryReactorStakeShareRequest", QueryReactorStakeShareRequest],
  ["/structs.structs.QueryReactorStakeShareResponse", QueryReactorStakeShareResponse],
  ["/structs.structs.QueryValidateSignatureRequest", QueryValidateSignatureRequest],
  ["/structs.structs.QueryValidateSignatureResponse", QueryValidateSignatureResponse],
  ["/structs.structs.QueryVaultRequest", QueryVaultRequest],
  ["/structs.structs.QueryVaultResponse", QueryVaultResponse],
  ["/structs.structs.Reactor", Reactor],
  ["/structs.structs.ReactorDiversityPosition", ReactorDiversityPosition],
  ["/structs.structs.Struct", Struct],
  ["/structs.structs.StructAttributeRecord", StructAttributeRecord],
  ["/structs.structs.StructAttributes", StructAttributes],
  ["/structs.structs.StructDefender", StructDefender],
  ["/structs.structs.StructDefenders", StructDefenders],
  ["/structs.structs.StructDestructionQueueRecord", StructDestructionQueueRecord],
  ["/structs.structs.StructType", StructType],
  ["/structs.structs.StructsPacketData", StructsPacketData],
  ["/structs.structs.Substation", Substation],
  ["/structs.structs.VaultVestingAccount", VaultVestingAccount],
  ["/structs.structs.VaultVestingSchedule", VaultVestingSchedule],
  ["/structs.structs.module.Module", Module],
];
